import pimg2 from '../images/gallery/1.png';
import pimg1 from '../images/gallery/2.png';
import pimg3 from '../images/gallery/3.png';
import pimg4 from '../images/gallery/4.png';
import pimg5 from '../images/gallery/7.jpg';
import pimg6 from '../images/gallery/6.jpg';


import p2img1 from '../images/project-single/1.jpg'
import p2img2 from '../images/project-single/2.jpg'
import p2img3 from '../images/project-single/3.jpg'






const Gallery = [
  {
    id: "1",
    title: "Quirófanos",
    subtitle: "Treatment",
    docomunt:
      "Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit",
    slug: "Heart-Institure",
    pimg1: pimg1,
    pSimg: p2img1,
    location: "7 Lake Street,London",
    date: "15 Dec 2024",
    orientation: "vertical", // Orientación predefinida (opcional)
  },
  {
    id: "2",
    title: "Entrada Principal",
    subtitle: "Treatment",
    docomunt:
      "Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit",
    slug: "Orthopaedics-Center",
    pimg1: pimg2,
    pSimg: p2img2,
    location: "7 Lake Street,London",
    date: "15 Dec 2024",
    orientation: "horizontal", // Orientación predefinida (opcional)
  },
  {
    id: "3",
    title: "Area de Recuperación",
    subtitle: "Treatment",
    docomunt:
      "Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit",
    slug: "Neurology-Services",
    pimg1: pimg3,
    pSimg: p2img3,
    location: "7 Lake Street,London",
    date: "15 Dec 2024",
    orientation: "vertical", // Orientación predefinida (opcional)
  },
  {
    id: "4",
    title: "Recepción",
    subtitle: "Treatment",
    docomunt:
      "Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit",
    slug: "Heart-Institure",
    pimg1: pimg4,
    pSimg: p2img1,
    location: "7 Lake Street,London",
    date: "15 Dec 2024",
    orientation: "horizontal", // Orientación predefinida (opcional)
  },
  {
    id: "5",
    title: "Quirófano",
    subtitle: "Treatment",
    docomunt:
      "Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit",
    slug: "Orthopaedics-Center",
    pimg1: pimg5,
    pSimg: p2img2,
    location: "7 Lake Street,London",
    date: "15 Dec 2024",
    orientation: "wide", // Orientación predefinida (opcional) - para imágenes panorámicas
  },
  {
    id: "6",
    title: "Quirófano",
    subtitle: "Treatment",
    docomunt:
      "Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit",
    slug: "Neurology-Services",
    pimg1: pimg6,
    pSimg: p2img3,
    location: "7 Lake Street,London",
    date: "15 Dec 2024",
    orientation: "vertical", // Orientación predefinida (opcional)
  },
];
export default Gallery;






